import React, { Component } from "react";
import Panel from "../../../components";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  HelpBlock,
  Alert
} from "react-bootstrap";
import { createBrowserHistory } from "history";

import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import loader from "../../../style/loader/loader.scss";
import { withRouter, Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import isEmpty from "lodash.isempty";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";

import FormValidator from "../../../_helpers/FormValidator";

import "rc-color-picker/assets/index.css";
import ColorPicker from "rc-color-picker";

import { designCenterActions } from "../../../redux/actions/designCenterActions";
import {
  renderAlert,
  clearAlert,
  alertsActions
} from "../../../redux/actions/alertsActions";
import {aclUtil} from "../../util"

const history = createBrowserHistory();

class AssetColorAdd extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);

    this.validator = new FormValidator([
      {
        field: "started_at",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "ended_at",
        method: "isEmpty",
        validWhen: false,
        message: "Field is required."
      },
      {
        field: "background_color",
        method: "isEmpty", // notice that we are passing a custom function here
        validWhen: false,
        message: "Please choose Color."
      },
    ]);

    this.state = {
      menuKey: 'ADD_ASSET_COLOR',
      path: ["Home", "Assets Color Lists", "Add Color New"],
      links:['home','assets/color/list','asset/color/add'],
      asset_type: "header",
      assetColorDetail: {},
      started_at: "",
      ended_at: "",
      name: "",
      background_color: "#26B99A",
      status: "1",
      msg_status: "hide",
      alertMessage: "",
      show: false,
      msgType: "",
      loading: false,
      message: "",
      currDate: new Date(),
      validation: this.validator.valid(),
      cityList: [],
      cityID: '',
    };

    this.handleInputChange = this.handleInputChange.bind(this);

    this.submitted = false;
  }

  checkDateRange = (checkDate, state) => {
    let startedAt = new Date(state.started_at);
    let endedAt = new Date(state.ended_at);
    let currDate = new Date();
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  onDateChange = (dtype, date) => {
    this.setState({
      [dtype]: date
    });
  };

  componentDidMount() {
    const {
      actions: { getCityDetail }
    } = this.props;
    getCityDetail();
    if (this.props.error) {
      this.setState({ loading: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.assetColorDetail !== nextProps.assetColorDetail) {
      if (nextProps.assetColorDetail && nextProps.assetColorDetail.response) {
        this.setState({
          msgType: nextProps.assetColorDetail.response,
          message: nextProps.assetColorDetail.message,
          loading: false
        });
        window.scrollTo(0, 0);
      }
    }
    if(this.props.cityList != nextProps.cityList){
      if(nextProps.cityList){
        this.setState({cityList: nextProps.cityList.data});
      }
    }
    if (this.props.error !== nextProps.error) {
      if(nextProps.error){
        this.setState({
          msgType: "error",
          message: nextProps.error,
          loading: false
        });
      }
       window.scrollTo(0, 0);
    }

    setTimeout(
      function() {
        this.setState({
          msgType: "",
          message: ""
        });
      }.bind(this),
      5000
    );
  }

  handleFormSubmit = event => {
    event.preventDefault();
    if (this.state.asset_type != "slider") {
      const validation = this.validator.validate(this.state);
      this.setState({ validation });
      this.submitted = true;

      if (validation.isValid) {
        // handle actual form submission here
        const formData = new FormData();
        formData.append("cityID", this.state.cityID);
        formData.append("name", this.state.name);
        formData.append("value", this.state.background_color);
        formData.append("asset_type", this.state.asset_type);
        formData.append(
          "ended_at",
          moment(this.state.ended_at).format("YYYY-MM-DD HH:mm:ss")
        );
        formData.append(
          "started_at",
          moment(this.state.started_at).format("YYYY-MM-DD HH:mm:ss")
        );
        formData.append("status", this.state.status);
        const {
          actions: { addAssetColor }
        } = this.props;
        addAssetColor(formData);
        this.setState({
          loading: true
        });
      } else {
        this.setState({
          loading: false
        });
      }
    } else {
      const formData = new FormData();
      formData.append("asset_type", this.state.asset_type);
      formData.append("cityID", this.state.cityID);
      formData.append("status", this.state.status);
      const {
        actions: { addAssetColor }
      } = this.props;
      addAssetColor(formData);
      this.setState({
        loading: true
      });
    }
  };

  handleColorChange = event => {
    this.setState({
      background_color: event.color
    });
  };

  renderAlert() {
    if (this.state.msgType && this.state.message) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong>{" "}
          {this.state.message}
        </div>
      );
    }
  }

  render() {
    let validation;
    if (this.state.asset_type != "slider") {
      validation = this.submitted // if the form has been submitted at least once
        ? this.validator.validate(this.state) // then check validity every time we render
        : this.state.validation; // otherwise just use what's in state
    }
    let otherSetting, colorSetting;
    if (this.state.asset_type == "button") {
      otherSetting = (
        <FormGroup controlId="formAssetOptionType">
          <ControlLabel>
            {" "}
            <span style={{ color: "red" }}>*</span> Button Color
          </ControlLabel>
          <FormControl
            className="halfWidth"
            componentClass="select"
            name="name"
            style={{ borderColor: this.state.assetTypeError }}
            onChange={this.handleInputChange}
            value={this.state.name}
          >
            <option value="">Select</option>
            <option value="button_color">Button Color</option>
            <option value="mouseover_color">Mouseover Color</option>
          </FormControl>
        </FormGroup>
      );
    }
    if (this.state.asset_type == "menu_bar") {
      otherSetting = (
        <FormGroup controlId="formAssetOptionType">
          <ControlLabel>
            {" "}
            <span style={{ color: "red" }}>*</span>Menu Bar
          </ControlLabel>
          <FormControl
            className="halfWidth"
            componentClass="select"
            name="name"
            style={{ borderColor: this.state.assetTypeError }}
            onChange={this.handleInputChange}
            value={this.state.name}
          >
            <option value="">Select</option>
            <option value="menu_bar_color">Menu Bar Color</option>
            <option value="menu_bar_text">Menu Bar Text</option>
            <option value="top_menu_bar">Top Menu Text</option>
          </FormControl>
        </FormGroup>
      );
    }
    if (this.state.asset_type == "footer") {
      otherSetting = (
        <FormGroup controlId="formAssetOptionType">
          <ControlLabel>
            {" "}
            <span style={{ color: "red" }}>*</span>Footer
          </ControlLabel>
          <FormControl
            className="halfWidth"
            componentClass="select"
            name="name"
            style={{ borderColor: this.state.assetTypeError }}
            onChange={this.handleInputChange}
            value={this.state.name}
          >
            <option value="">Select</option>
            <option value="footer_color">Footer Color</option>
            <option value="footer_text_color">Footer Text Color</option>
            <option value="footer_social_link_color">
              Footer Social Links
            </option>
          </FormControl>
        </FormGroup>
      );
    }
    if (this.state.asset_type !== "slider") {
      colorSetting = (
        <div>
          <FormGroup
            controlId="formBackgroundColor"
            className={validation.background_color.isInvalid && "has-error"}
          >
            <ControlLabel>
              {" "}
              <span style={{ color: "red" }}>*</span>Color (in hex code)
            </ControlLabel>
            <FormControl
              type="text"
              value={this.state.background_color}
              placeholder="Color"
              onChange={this.handleInputChange}
              name="background_color"
              style={{ borderColor: this.state.backgroundColorError }}
            />
            <ColorPicker
              color={this.state.background_color}
              name="background_color"
              onChange={this.handleColorChange}
              value={this.state.background_color}
            >
              <span className="react-custom-trigger">Choose Color</span>
            </ColorPicker>
            <span className="help-block">
              {validation.background_color.message}
            </span>
          </FormGroup>
          <FormGroup
            className={
              (validation.started_at.isInvalid ||
                validation.ended_at.isInvalid) &&
              "has-error"
            }
          >
            <ControlLabel className="halfWidth">Schedule</ControlLabel>
            Start
            <DateTimePicker
              name="started_at"
              value={this.state.started_at}
              // minDate={this.state.currDate}
              onChange={this.onDateChange.bind(this, "started_at")}
            />
            <span className="help-block">{validation.started_at.message}</span>
            <ControlLabel className="halfWidth">Until</ControlLabel>
            <DateTimePicker
              name="ended_at"
              value={this.state.ended_at}
              // minDate={this.state.started_at}
              onChange={this.onDateChange.bind(this, "ended_at")}
            />
            <span className="help-block">{validation.ended_at.message}</span>
          </FormGroup>
        </div>
      );
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {this.state.loading === true ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <form>
          {this.renderAlert()}
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              New Asset Color
              <Button
                bsSize="xsmall"
                bsStyle="success"
                onClick={() => this.context.router.history.push("/assets/color/list")}
              >
                {" "}
                Assets Color Listing{" "}
              </Button>
            </header>

            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={8} xs={12} mdOffset={2}>
                    <FormGroup controlId="formAssetType">
                      <ControlLabel>
                        {" "}
                        <span style={{ color: "red" }}>*</span> Asset Type
                      </ControlLabel>
                      <FormControl
                        className="halfWidth"
                        componentClass="select"
                        name="asset_type"
                        style={{ borderColor: this.state.assetTypeError }}
                        onChange={this.handleInputChange}
                        value={this.state.asset_type}
                      >
                        <option value="header">Header</option>
                        <option value="button">Button</option>
                        <option value="menu_bar">Menu Bar</option>
                        <option value="footer">Footer</option>
                        <option value="slider">Slider</option>
                      </FormControl>
                    </FormGroup>
                    {otherSetting}
                    {colorSetting}
                    <FormGroup controlId="formDisplayCity">
                      <ControlLabel>City</ControlLabel>
                      <FormControl componentClass="select" value={this.state.cityID} name="cityID" placeholder="select" onChange={this.handleInputChange}>
                          <option value="">All City</option>
                          {(this.state.cityList) &&
                            this.state.cityList.map((data, index) =>
                              <optgroup key={'hcity'+index} label={data.country}>
                                {(data.cities) &&
                                  data.cities.map((city, index) => 
                                    <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                  )
                                }
                              </optgroup>
                            )
                          }
                      </FormControl>
                    </FormGroup>
                    <FormGroup controlId="formStatus">
                      <ControlLabel>Status</ControlLabel>
                      <FormControl
                        componentClass="select"
                        name="status"
                        onChange={this.handleInputChange}
                        value={this.state.status}
                      >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </FormControl>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <Row className="BtnRow">
            <Col md={12} xs={12}>
              <Button
                bsStyle="info"
                type="button"
                onClick={this.handleFormSubmit}
                id="saveButton"
                disabled={this.props.loading}
              >
                Save
              </Button>
              <Button
                bsStyle="default"
                onClick={() => this.context.router.history.push(`/assets/color/list`)}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.designCenterReducer.error,
    assetColorDetail: state.designCenterReducer.assetColorDetail,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    loading: state.designCenterReducer.loading,
    cityList: state.frontReducer.cityList,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        ...designCenterActions,
        ...alertsActions
      },
      dispatch
    )
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetColorAdd));



// WEBPACK FOOTER //
// ./src/app/views/admin/designCenter/AssetColorAdd.js